export default __webpack_public_path__ + "static/media/bonus3.375721eb.webm";